// أنواع بيانات Bosta للشحن

export interface BostaConfig {
  enabled: boolean;
  apiKey: string;
  businessId?: string;
  defaultPickupCity: string;
  defaultPickupZone: string;
  defaultPickupDistrict: string;
  defaultPickupStreet: string;
  defaultPickupBuilding: string;
  defaultPickupFloor?: string;
  defaultPickupApartment?: string;
  defaultPickupPhone: string;
  deliveryType: '10' | '15'; // 10 = Deliver, 15 = Cash Collection
  enableCOD: boolean;
  webhookUrl?: string;
}

export interface BostaAddress {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  street: string;
  building: string;
  apartment?: string;
  floor?: string;
  city: string;
  zone: string;
  district: string;
  notes?: string;
}

// Bosta API address format
export interface BostaApiAddress {
  city: string;                    // City name from cities list (Required)
  districtId?: string;             // District ID (Required unless districtName+cityId provided)
  districtName?: string;           // District name (Required when districtId not provided)
  cityId?: string;                 // City ID (Required when using districtName)
  zoneId?: string;                 // Zone ID from /cities/{cityId}/zones (Optional)
  firstLine: string;               // Address line 1 (Required, must be > 5 chars)
  secondLine?: string;             // Nearby landmark (Optional)
  buildingNumber?: string;         // (Optional)
  floor?: string;                  // (Optional)
  apartment?: string;              // Apartment number (Optional)
  isWorkAddress?: boolean;
}

export interface BostaDeliveryRequest {
  type: '10' | '15' | '25' | '30';
  specs: {
    packageDetails: {
      description: string;
      itemsCount: number;
    };
    packageType: 'SMALL' | 'MEDIUM' | 'LARGE' | 'Light Bulky' | 'Heavy Bulky';
  };
  pickupAddress?: BostaApiAddress;
  dropOffAddress?: BostaApiAddress;
  businessLocationId?: string;
  cod?: number;
  notes?: string;
  webhookUrl?: string;
  businessReference?: string;
  allowOpenPackage?: boolean;
  goodsInfo?: {
    goodsType: string;
    description: string;
  };
}

export interface BostaDeliveryResponse {
  _id: string;
  trackingNumber: number;
  state: number;
  type: string;
  cod: number;
  notes: string;
  businessReference: string;
  createdAt: string;
  pricing: {
    subtotal: number;
    discount: number;
    vat: number;
    total: number;
  };
  waybillUrl: string;
}

export interface BostaTrackingEvent {
  state: number;
  stateName: string;
  timestamp: string;
  exceptionReason?: string;
  exceptionCode?: number;
}

export interface BostaTrackingResponse {
  _id: string;
  trackingNumber: number;
  state: number;
  stateName: string;
  type: string;
  cod: number;
  isConfirmedDelivery: boolean;
  exceptionReason?: string;
  exceptionCode?: number;
  events: BostaTrackingEvent[];
}

export interface BostaCity {
  _id: string;
  name: string;
  active: boolean;
  zones: BostaZone[];
}

export interface BostaZone {
  _id: string;
  name: string;
  active: boolean;
  districts?: BostaDistrict[];
}

export interface BostaDistrict {
  _id: string;
  name: string;
  active: boolean;
}

export interface BostaPickupLocation {
  _id: string;
  name: string;
  city: string;
  zone: string;
  district: string;
  street: string;
  building: string;
  floor: string;
  apartment: string;
  phone: string;
  isDefault: boolean;
}

export interface BostaRateRequest {
  businessLocationId?: string;
  dropOffCity: string;
  dropOffZone: string;
  dropOffDistrict: string;
  packageType: 'SMALL' | 'MEDIUM' | 'LARGE' | 'Light Bulky' | 'Heavy Bulky';
  itemsCount: number;
  cod?: number;
}

export interface BostaRateResponse {
  subtotal: number;
  discount: number;
  vat: number;
  total: number;
  estimatedDeliveryDays: number;
}

export const BOSTA_STATE_MAP: Record<number, string> = {
  10: 'طلب استلام جديد',
  11: 'قيد التجهيز',
  20: 'تم تعيين المسار',
  21: 'تم الاستلام من المتجر',
  22: 'في الطريق للعميل',
  23: 'تم الاستلام من العميل',
  24: 'تم الاستلام في المستودع',
  25: 'مكتمل',
  30: 'قيد النقل بين المستودعات',
  40: 'في الطريق للاستلام',
  41: 'تم الاستلام',
  45: 'تم التوصيل بنجاح',
  46: 'تم الإرجاع للمتجر',
  47: 'استثناء',
  48: 'منتهي',
  49: 'ملغي',
  60: 'تم الإرجاع للمخزون',
  100: 'مفقود',
  101: 'تالف',
  102: 'تحقيق',
  103: 'بانتظار اجراءك',
  104: 'مؤرشف',
  105: 'معلق'
};
